import TooltipInfoIcon from '@publicImages/svg/tooltip-info.svg?static';

const UpliftTooltipIcon = () => (
  <span className="Icon UpliftTooltipIcon">
    <TooltipInfoIcon />
  </span>
);

export default UpliftTooltipIcon;
